import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import SurveyListHeader from "../../../component/layout/MainHeader";
import Input from "../../../core/Inputs/DefaultInput";
import { toast } from 'react-toastify';
import './profile.css';
import * as Yup from "yup";
import Button from "../../../core/Button";
import AccountSettingSidebar from "./components/AccountSettingSidebar";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import NestedMenuToggle from "./NestedMenuToggle";
import { addSetting, getSettingList, sendEmail } from "../../../store/actions/settingAction";
//import nodemailer from 'nodemailer';

const AwsSchema = Yup.object().shape({
  smtpHost: Yup.string().required("SMTP Host is required"),
  smtpPort: Yup.string().required("SMTP Port is required"),
  smtpUsername: Yup.string().required("SMTP Username is required"),
  smtpPassword: Yup.string().required("SMTP Password is required"),
  adminEmailFrom: Yup.string().required("Email From is required"),
  adminEmailFromName: Yup.string().required("email Form Name is required"),
});

export default function Smtp() {
  const dispatch = useDispatch();
  const { settingData } = useSelector((state) => state.settingData);

  const [formValue, setFormValue] = useState({
    smtpHost: "",
    smtpPort: "",
    smtpUsername: "",
    smtpPassword: "",
    adminEmailFrom: "",
    adminEmailFromName: ""
  });

  const handleSubmit = (values) => {
    dispatch(addSetting(values));
    handleGetSettingList(); 
  };
  const handleGetSettingList = () => {
    let payload = {
      tag: 'smtp',
    };
    dispatch(getSettingList(payload));
  }

  useEffect(() => {
    handleGetSettingList();

  }, [])

  const getSMTPConfig = (selector) => {
    const config = {};
    selector.forEach(item => {
      switch (item.type) {
        case 'smtpHost':
          config.smtpHost = item.value;
          break;
        case 'smtpPort':
          config.smtpPort = item.value;
          break;
        case 'smtpUsername':
          config.smtpUsername = item.value;
          break;
        case 'smtpPassword':
          config.smtpPassword = item.value;
          break;
        case 'adminEmailFrom':
          config.adminEmailFrom = item.value;
          break
        case 'adminEmailFromName':
          config.adminEmailFromName = item.value;
        default:
          break;
      }
    });
    return config;
  };
  const smtpConfig = useCallback(getSMTPConfig(settingData), [settingData]);
  useEffect(() => {
    setFormValue(smtpConfig);
  }, [smtpConfig]);
  // const smtpConfig = getSMTPConfig(settingData);
  // setFormValue(smtpConfig); 
  //console.log("smtpConfigformValue",formValue)
  const handleSendTestEmail = async () => {
    const payload = {
      host: formValue.smtpHost,
      port: formValue.smtpPort,
      user: formValue.smtpUsername,
      pass: formValue.smtpPassword,
      emailFrom: formValue.adminEmailFrom,
      to:formValue.adminEmailFromName
    }
    //dispatch(sendEmail(payload));
    try {  
      const response = await dispatch(sendEmail(payload));
      if (response.result === 'success') {  
       toast.success('Email sent successfully!');  
      } else {  
       toast.error('Error sending email!');  
      }  
     } catch (error) {  
      toast.error('Error sending email!');  
     }
  };
  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      Home
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>Smtp settings</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              {/* breadcrumbs ends here */}
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Account settings</h1>
                    </div>
                  </div>
                </div>
                <div className="pagesRow varPg">
                  <div className="profile-wrapper">
                    <div className="account-info border-0 pb-0">
                      <Formik
                        initialValues={formValue}
                        enableReinitialize
                        validationSchema={AwsSchema}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                          handleSubmit(values);
                          setSubmitting(false);
                          resetForm();
                          toast.success("Settings saved successfully");
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <div className="form-wrapper custom-width">
                              <div className="row gx-12px">
                                <div className="col-lg-6 position-relative">
                                  <div className="mb-3">
                                    <label htmlFor="awsAccessKey">SMTP host</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="Smtp Host"
                                      clearButton={true}
                                      success={false}
                                      error={errors.smtpHost && touched.smtpHost}
                                      fill={true}
                                      className={"formsinput"}
                                      name="smtpHost"
                                      value={values.smtpHost}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.smtpHost && touched.smtpHost && (
                                      <div className="validation-msg">
                                        {errors.smtpHost}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div className="mb-3">
                                    <label htmlFor="smtpPort">SMTP port</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="AWS Secret Key"
                                      clearButton={true}
                                      success={false}
                                      error={errors.smtpPort && touched.smtpPort}
                                      fill={true}
                                      className={"formsinput"}
                                      name="smtpPort"
                                      value={values.smtpPort}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.smtpPort && touched.smtpPort && (
                                      <div className="validation-msg">
                                        {errors.smtpPort}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6 position-relative">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="smtpUsername">SMTP username</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="Smtp Username"
                                      clearButton={true}
                                      success={false}
                                      error={errors.smtpUsername && touched.smtpUsername}
                                      fill={true}
                                      className={"formsinput"}
                                      name="smtpUsername"
                                      value={values.smtpUsername}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.smtpUsername && touched.smtpUsername && (
                                      <div className="validation-msg">
                                        {errors.smtpUsername}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6 position-relative">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="smtpPassword">SMTP password</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="Smtp Password"
                                      clearButton={true}
                                      success={false}
                                      error={errors.smtpPassword && touched.smtpPassword}
                                      fill={true}
                                      className={"formsinput"}
                                      name="smtpPassword"
                                      value={values.smtpPassword}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.smtpPassword && touched.smtpPassword && (
                                      <div className="validation-msg">
                                        {errors.smtpPassword}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="emailForm">Email form</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="Email Form"
                                      clearButton={true}
                                      success={false}
                                      error={errors.adminEmailFrom && touched.adminEmailFrom}
                                      fill={true}
                                      className={"formsinput"}
                                      name="adminEmailFrom"
                                      value={values.adminEmailFrom}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.adminEmailFrom && touched.adminEmailFrom && (
                                      <div className="validation-msg">
                                        {errors.adminEmailFrom}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3 cstom-select">
                                    <label htmlFor="adminForm">Email form name</label>
                                    <Input
                                      type="text"
                                      view="outlined"
                                      dense={false}
                                      color="default"
                                      placeholder="Admin Form"
                                      clearButton={true}
                                      success={false}
                                      error={errors.adminEmailFromName && touched.adminEmailFromName}
                                      fill={true}
                                      className={"formsinput"}
                                      name="adminEmailFromName"
                                      value={values.adminEmailFromName}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors.adminEmailFromName && touched.adminEmailFromName && (
                                      <div className="validation-msg">
                                        {errors.adminEmailFromName}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="btn-wrap">
                                <button
                                  className={"formsbutton btn-bordered btn mb-0"}
                                  type="submit"
                                  view="outlined"
                                  color="primary"
                                  disabled={isSubmitting}
                                >
                                  Save changes
                                </button>
                                
                               
                            <a className={"formsbutton btn-bordered ms-3 color-cancel btn mb-0"}
                                        onClick={handleSendTestEmail}
                                      >
                                        Send test email
                            </a>
                              </div>

                            </div>
                          </form>
                        )}
                      </Formik>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
